export const getSessionMonitoringAuthData = async (fetchSessionMonitoringAuth, returnPortalId) => {
  const auth = await fetchSessionMonitoringAuth({ portal_id: returnPortalId })

  return auth.auth_data
}
